<div class="content" style="background-color: #ffffff; padding: 25px 25px 0px 25px;">
  <div class="flex-column">
    <div class="flex mobile-column bg-img" style="margin-left: -25px; margin-right: -25px; padding: 0 25px; margin-bottom: 20px;">
      <h1 style="flex: 1; margin: 0;">{{'Bookings Management' | translate}}</h1>
    </div>

    <div class="flex mobile-column" style="gap: 15px; margin-bottom: 20px;">
      <!-- Location Selector -->
      <div style="flex: 1;">
        <span class="noprint" style="display: block; margin-bottom: 8px; font-weight: 500;">{{'Select Location' | translate}}</span>
        <select
          class="noprint"
          [value]="selectedLocation?._id"
          (change)="onLocationChange($event.target.value)"
          style="width: 100%;"
        >
          <option *ngFor="let location of locations" [value]="location._id">
            {{location.name}}
          </option>
        </select>
      </div>

      <!-- Date Selector -->
      <div style="flex: 1;">
        <span class="noprint" style="display: block; margin-bottom: 8px; font-weight: 500;">{{'Select Date' | translate}}</span>
        <div style="display: flex; align-items: center; gap: 10px;">
          <button
            (click)="changeDay(-1)"
            class="cta-button"
            style="background: var(--accent); padding: 10px 15px; flex-shrink: 0; -webkit-text-stroke-width: 0 !important; -webkit-text-stroke-color: transparent !important;"
            [disabled]="isLoading"
          >
            <i class="fas fa-chevron-left" style="color: white;"></i>
          </button>
          <input
            type="date"
            [value]="getTodayForInput()"
            (change)="onDateChange($event)"
            style="flex: 1; padding: 8px 12px; border: 1px solid #ccc; border-radius: 4px;"
          />
          <button
            (click)="changeDay(1)"
            class="cta-button"
            style="background: var(--accent); padding: 10px 15px; flex-shrink: 0; -webkit-text-stroke-width: 0 !important; -webkit-text-stroke-color: transparent !important;"
            [disabled]="isLoading"
          >
            <i class="fas fa-chevron-right" style="color: white;"></i>
          </button>
        </div>
        <div style="margin-top: 10px; text-align: center; color: #666; font-size: 14px;">
          {{formatDateForDisplay(selectedDate)}}
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div
      *ngIf="error"
      class="card"
      style="background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;"
    >
      <i class="fas fa-exclamation-circle"></i> {{error}}
    </div>

    <!-- Bookings Table -->
    <div class="card">
      <div class="title">
        {{'Bookings for' | translate}} {{selectedLocation?.name}} - 
        {{formatDateForDisplay(selectedDate)}}
      </div>

      <div *ngIf="isLoading" style="text-align: center; padding: 20px;">
        <img
          class="spin"
          src="../../../assets/img/loading.svg"
          style="width: 30px;"
        />
      </div>

      <div class="responsive-table">
        <table>
          <thead>
            <tr class="head">
              <th>{{'Room' | translate}}</th>
              <th>{{'Bookable' | translate}}</th>
              <th>{{'User' | translate}}</th>
              <th>{{'Time Slots' | translate}}</th>
              <th>{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let booking of bookings">
              <td>{{booking.roomName}}</td>
              <td>{{booking.bookableName}}</td>
              <td>{{booking.userName}}</td>
              <td>{{booking.timeSlots}}</td>
              <td style="text-align: center;">
                <button
                  (click)="deleteBooking(booking)"
                  [disabled]="isLoading"
                  style="padding: 8px 16px; font-size: 14px; background: #FFD700; border: none; border-radius: 4px; color: #333; font-weight: 500; cursor: pointer; -webkit-text-stroke-width: 0 !important; -webkit-text-stroke-color: transparent !important;"
                >
                  {{'Delete' | translate}}
                </button>
              </td>
            </tr>
            <tr *ngIf="bookings.length === 0 && !isLoading">
              <td colspan="5" style="text-align: center; padding: 40px; color: #999;">
                <i class="fas fa-calendar-times fa-3x" style="display: block; margin-bottom: 15px;"></i>
                {{'No bookings found for this date and location.' | translate}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
